import request from "@/utils/request";
import qs from "qs";

// 新增接口统一日期后缀，旧store.js中的省级模板接口仍保留。
const get = (path, params) => request.get(`/postages/${path}/1026`, { params });
const post = (path, params) =>
  request.post(`/postages/${path}/1026`, qs.stringify(params));
export const freightRegions = () => get("regions");
export const freightList = params => get("getList", params);
export const freightDetail = id => get("detail", { id });
export const freightSave = template =>
  post("save", { template: JSON.stringify(template) });
export const freightCopy = params => post("copy", params);
export const freightDelete = params => post("delete", params);
export const freightGoods = params => get("goods", params);
export const freightQuote = params => get("quote", params);
